<script setup lang="ts">
import BackgroundGradient from '@/components/BackgroundGradient.vue'
import UpsellModal from '@/components/UpsellModal.vue'
import useMerchant from '@/composables/merchant'
const { stores, user } = useLocalStorage()
const { t } = useI18n()
const { send } = useEvent()
const { getStoreSchedulingPlatformUrl } = useStore()

withDefaults(
  defineProps<{
    hasImage?: boolean
  }>(),
  {
    hasImage: true
  }
)

const { isEligibleForSmsUpsell } = useMerchant()
const isUpsellModalOpened = ref(false)

const continueTrackingEvent = 'product:new:viewed'

const helperCard = {
  title: t('upsell.banner.smsPack.modal.helperCard.title'),
  steps: [t('upsell.banner.smsPack.modal.helperCard.step1'), t('upsell.banner.smsPack.modal.helperCard.step2')]
}
const success = {
  title: t('upsell.banner.smsPack.modal.success.title'),
  text: t('upsell.banner.smsPack.modal.success.text'),
  linkText: t('upsell.banner.smsPack.modal.success.linkText')
}

const links = {
  reminder: `${getStoreSchedulingPlatformUrl()}?utm_source=pongo&utm_medium=dashboard&utm_campaign=conversion-self-served&utm_content=dashboard`,
  activate: '#'
}

const activateSmsPacks = (selectedStores) => {
  selectedStores.forEach((selectedStore) => {
    const storeData = stores.value.find((store) => store.id === selectedStore.storeId)

    const data = {
      merchantPublicId: user.value.merchant.publicId,
      merchantName: user.value.merchant.name,
      crmOwnerIdentifier: storeData.ownerCsm?.crmContactIdentifier.toString(),
      crmDealIdentifier: storeData.businessCrmIdentifier?.toString(),
      crmCompanyIdentifier: user.value.merchant.businessCrmIdentifier?.toString(),
      storeId: storeData.storeId,
      storePublicId: storeData.public_id,
      storeName: storeData.name,
      product: {
        productName: 'packSms',
        packSmsId: selectedStore.packSmsId,
        packSms: selectedStore.packSms,
        price: selectedStore.price
      }
    }
    send('segment', 'product:create:clicked', data)
  })
}
const handleSchedulingRedirection = () => {
  send('segment', 'scheduling.new:clicked')
  isUpsellModalOpened.value = false
}
const openUpsellModal = () => {
  send('segment', 'product:viewed')
  isUpsellModalOpened.value = true
}

const imgStickerPackSms = computed(() => `${import.meta.env.VITE_AWS_STORAGE_URL}/campaigns/sms-pack.png`)
</script>
<template>
  <BackgroundGradient
    v-if="isEligibleForSmsUpsell"
    :has-caret="false"
    background-color="bg-primary"
    class="my-4 hover:cursor-pointer"
    @click="openUpsellModal"
  >
    <div class="py-4 text-sm" :class="{ 'flex flex-col justify-between sm:flex-row sm:items-center': !hasImage }">
      <h2 class="font-semibold text-white" :class="{ 'mb-4': hasImage }">
        {{ t('pages.campaign.campaignCreatePage.upsell.title') }}
      </h2>
      <span class="flex font-bold text-white">
        {{ t('pages.campaign.campaignCreatePage.upsell.button') }}
        <BaseIcon name="HeroArrowLongRightIconOutline" class="ml-2 w-5" />
      </span>
      <img v-if="hasImage" :src="imgStickerPackSms" class="absolute -bottom-4 -right-4 w-16" alt="Pack SMS" />
    </div>
    <UpsellModal
      :title="t('upsell.banner.smsPack.modal.addPackTitle')"
      :show="isUpsellModalOpened"
      :helper-card="helperCard"
      :is-sms="true"
      :success="success"
      :links="links"
      :continue-tracking-event="continueTrackingEvent"
      @on-close-modal="handleSchedulingRedirection"
      @on-activate="activateSmsPacks"
    />
  </BackgroundGradient>
</template>
